module.exports = __webpack_public_path__ + "fd2d36c7c608fd0aba81c3ff26e5f15f.fbx";